module.exports = __webpack_public_path__ + "img/Weapon_103.9a910f4f.png";